import React, { useState, useEffect } from "react";
import ProductCard from "./ProductCard";
import ListColors from "./ListColors";
import SliderProducts from "./SliderProducts";

const TipoArea = ({ tipo, products, cores }) => {
  const [currentColors, setCurrentColors] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [actives, setActives] = useState({
    cor: {},
    tipo: {},
  });

  const filterProductsByType = (id) =>
    products.filter(({ tipo }) => tipo.map(({ id }) => id).includes(id));

  const getColorsFromItems = (items) => {
    const allColors = items.map(({ cor }) => cor).flat();
    const res = [...new Set(allColors.map(({ id }) => id))].map(
      (i) => cores[i]
    );
    return res;
  };

  const handleSelectTipo = (id) => {
    const filtered = filterProductsByType(id);
    const filteredColor = getColorsFromItems(filtered);

    setSelectedProducts([]);
    setActives({ cor: filteredColor[0], tipo: tipo.items[id] });
    setCurrentColors(getColorsFromItems(filtered));
    setSelectedProducts(filterProductsByColor(filteredColor[0].id, id));
  };

  const filterProductsByColor = (corId, tipoId) =>
    products
      .filter(({ tipo }) => tipo.map(({ id }) => id).includes(tipoId))
      .filter(({ cor }) => cor.map(({ id }) => id).includes(corId));

  const filterProducts = (corId, tipoId) =>
    products
      .filter(({ tipo }) => tipo.map(({ id }) => id).includes(tipoId))
      .filter(({ cor }) => cor.map(({ id }) => id).includes(corId));

  const selectProducts = (id) => {
    setActives((actives) => ({ ...actives, cor: cores[id] }));
    setSelectedProducts(filterProductsByColor(id, actives.tipo.id));
  };
  useEffect(() => {
    const firstTipo = Object.values(tipo.items)[0];

    if (products.length) {
      const firstCor = getColorsFromItems(
        filterProductsByType(firstTipo.id)
      )[0];

      handleSelectTipo(firstTipo.id);
      setSelectedProducts(filterProducts(firstCor.id, firstTipo.id));
      setActives({
        tipo: firstTipo,
        cor: firstCor,
      });
    }
  }, [products]);

  return (
    <div className="produtos-area u-paddings" key={tipo.id}>
      <div className="row">
        <div className="col-xs-12 col-sm-3">
          <h2>{tipo.name || "Rígidos"}</h2>
        </div>
        <div className="col-xs-12 col-sm-9">
          <div className="list-tipos">
            {Object.entries(tipo.items).map(([, item]) => (
              <button
                className={actives.tipo.id === item.id ? "active" : ""}
                key={`tipo_${item.id}`}
                onClick={() => handleSelectTipo(item.id)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      </div>
      {currentColors && (
        <ListColors
          active={actives.cor.id}
          action={selectProducts}
          colors={currentColors}
        />
      )}
      {!selectedProducts.length && <h4>Selecione um tipo e uma cor</h4>}
      {!!selectedProducts.length && (
        <SliderProducts selectedProducts={selectedProducts} />
      )}
    </div>
  );
};

export default TipoArea;
